<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'room.addingAreas' | translate }}
  </div>
  <div>
    <p>
      {{ 'room.addingAreasInfo' | translate }}
    </p>
    <form class="ion-padding-bottom"
      [formGroup]="formGroup"
      (ngSubmit)="save()">
      <form formArrayName="areas">
        <h4>{{ 'room.areaName' | translate }}</h4>
        @for (item of getFields().controls; track item; let i = $index) {
          <ion-item lines="none"
            [formGroupName]="i">
            <ion-input autocapitalize="on"
              formControlName="name"
              [placeholder]="'room.example' | translate:{index: (i + 1)}"></ion-input>
            <ion-input autocapitalize="on"
              formControlName="floor"
              [label]="'room.floor' | translate"></ion-input>
            <ion-icon slot="end"
              color="danger"
              name="remove-circle-outline"
              (click)="deleteItem(i)"></ion-icon>
          </ion-item>
        }
      </form>
      <div class="ion-margin-top">
        <ion-button color="secondary"
          shape="round"
          (click)="addItem()">
          <ion-icon slot="start"
            name="add-outline"></ion-icon>
          {{ 'item.addRow' | translate }}
        </ion-button>
      </div>
      <div class="ion-margin-top">
        <ion-button color="light"
          shape="round"
          type="submit"
          [disabled]="!formGroup.valid">{{ 'general.save' | translate }}</ion-button>
      </div>
    </form>
  </div>
</app-main-dialog>